import { useCallback, useEffect, useState } from "react";
import { debounce, formValidator, getFormElementData } from "../util/Helpers";


const useValidation = (formRef, autoFocus = false, key) => {
    // Validation state
    const [validation, setValidation] = useState({validated: false, allValid: false, fields:{}});
    const [data, setData] = useState({});

    // Auto validation on field change
    const handleChange = useCallback(_ => {
        setData(getFormElementData(formRef.current));
        setValidation(currData => formValidator(formRef.current, currData));
    }, [formRef]);

    const markAsValidated = useCallback(_ => {
        setValidation(currData => ({...currData, validated: true}));
        handleChange();
    }, [handleChange]);

    const resetForm = _ => {
        formRef.current?.reset();
        setData({});
        setValidation({validated: false, allValid: false, fields:{}});
    }

    const resetValidated = useCallback(_ => {
        setValidation(currData => ({...currData, validated: false}));
    }, []);
    
    useEffect(_ => {
        formRef.current?.querySelector("button[type='submit']")?.addEventListener?.("click", markAsValidated)
        formRef.current?.addEventListener("input", debounce(handleChange, 50));
        formRef.current?.addEventListener("submit", e => {
            e.preventDefault();
            handleChange();
            // Stop propagation when all requirements not satisfied
            if (formRef.current.checkValidity() !== true){
                e.stopPropagation();
            }
        });
    }, [formRef, handleChange, markAsValidated, key]);

    // Validation check on first mount after little delay
    useEffect(_ => {
        const timeInterval = setInterval(handleChange, 1000);
        const timeOut = setTimeout(_ => clearInterval(timeInterval), 5000);    // Stop revalidation check after 5 sec
        return _ => {
            clearInterval(timeInterval);
            clearTimeout(timeOut);
        }
     }, [handleChange]);
     
     useEffect(_ => {
        // Auto Focus on first Input field
        if (autoFocus){
            const inputs = formRef.current?.querySelectorAll("form .form-input") || [];
            for (const node of inputs){
                if (["INPUT", "TEXTAREA"].includes(node.nodeName) && !node.readOnly && !node.disabled && !["Search...", "DD-MM-YYYY"].includes(node.placeholder)){
                    node.focus();
                    break;
                }
            }
        }
     }, [formRef, autoFocus, key])

    return {validation, data, setValidation, handleChange, markAsValidated, resetForm, resetValidated};
}

export default useValidation;